import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { DialogAlteracoesNaoSalvasComponent } from '../dialogs/dialog-alteracoes-nao-salvas/dialog-alteracoes-nao-salvas.component';

export interface ComponentComAlteracoesNaoSalvas {
  possuiAlteracoesNaoSalvas(): boolean;
  /** Roda a mesma lógica do botão Salvar da tela; emite true se salvou com sucesso, false se a
   * validação ou a chamada à API falhou (nesse caso a navegação é cancelada, o usuário fica na tela). */
  salvarAsync(): Observable<boolean>;
}

/** Guarda genérica: intercepta qualquer saída da rota (clique em botão, navegação direta, etc.) e,
 * se a tela tiver alterações não salvas, pergunta ao usuário se quer salvar, sair sem salvar ou
 * cancelar a navegação. */
@Injectable({ providedIn: 'root' })
export class AlteracoesNaoSalvasGuard implements CanDeactivate<ComponentComAlteracoesNaoSalvas> {

  constructor(private dialog: MatDialog) { }

  canDeactivate(component: ComponentComAlteracoesNaoSalvas): Observable<boolean> | boolean {
    if (!component.possuiAlteracoesNaoSalvas()) return true;

    const dialogRef = this.dialog.open(DialogAlteracoesNaoSalvasComponent, {
      width: '467px',
      panelClass: 'no-padding-dialog',
      disableClose: true,
    });

    return dialogRef.afterClosed().pipe(
      switchMap(resultado => {
        if (resultado === 'sair') return of(true);
        if (resultado === 'salvar') return component.salvarAsync();
        return of(false);
      }),
    );
  }
}
